// extracted by mini-css-extract-plugin
module.exports = {"with-bg-color":"row-m__with-bg-color__1GTdu","banner-photo":"row-m__banner-photo__3SVU4","with-no-bg-color":"row-m__with-no-bg-color__1WYwQ"};